import { createSelector } from '@ngrx/store';

import { selectLiveEdgeState } from './live-edge-base.selectors';

// Regular cameras selectors
export const camerasState = createSelector(selectLiveEdgeState, state => state.cameras);
export const selectIsCamerasListLoaded = createSelector(camerasState, camerasState => camerasState.loaded);
export const selectsCamerasListLoading = createSelector(camerasState, selectIsCamerasListLoaded, (camerasState, isCamerasListLoaded) => {
  return camerasState.isLoading && !isCamerasListLoaded;
});
export const selectCamerasEntities = createSelector(camerasState, camerasState => camerasState.entities);

export const selectCameras = createSelector(selectCamerasEntities, entities => Object.values(entities));
export const selectCameraById = (cameraId: string) => createSelector(selectCamerasEntities, cameras => cameras[cameraId]);

export const selectCamerasNextPage = createSelector(camerasState, state => state.nextPage);
export const selectTotalNumberOfCameras = createSelector(selectCamerasNextPage, nextPage => nextPage.totalCount || 0);
export const selectHasCamerasListError = createSelector(camerasState, state => state.error);
export const getSelectedCameraId = createSelector(camerasState, state => state.selectedCameraId);
export const getSelectedCamera = createSelector(
  selectCamerasEntities,
  getSelectedCameraId,
  (entities, selectedCameraId) => entities[selectedCameraId]
);

// Pinned cameras selectors
export const pinnedCamerasState = createSelector(selectLiveEdgeState, state => state.pinnedCameras);
export const selectIsPinnedCamerasListLoaded = createSelector(pinnedCamerasState, state => state.loaded);
export const selectIsPinnedCamerasListLoading = createSelector(
  pinnedCamerasState,
  selectIsPinnedCamerasListLoaded,
  (state, isPinnedCamerasListLoaded) => state.isLoading && !isPinnedCamerasListLoaded
);
export const selectPinnedCamerasEntities = createSelector(pinnedCamerasState, state => state.entities);
export const selectPinnedCameras = createSelector(selectPinnedCamerasEntities, entities => Object.values(entities));
export const selectPinnedCamerasNextPage = createSelector(pinnedCamerasState, state => state.nextPage);
export const selectTotalNumberOfPinnedCameras = createSelector(selectPinnedCamerasNextPage, nextPage => nextPage.totalCount || 0);
export const selectPinnedCameraById = (cameraId: string) => createSelector(selectPinnedCamerasEntities, cameras => cameras[cameraId]);

// Common selectors that work across both regular and pinned cameras
export const selectCameraThumbnailUrl = (cameraId: string) =>
  createSelector(selectCamerasEntities, selectPinnedCamerasEntities, (cameraEntities, pinnedEntities) => {
    // Check regular cameras first, then pinned cameras
    return cameraEntities[cameraId]?.thumbnailUrl || pinnedEntities[cameraId]?.thumbnailUrl;
  });

export const selectAreCamerasUpdating = (cameraIds: string[]) =>
  createSelector(selectCamerasEntities, entities => cameraIds.some(id => entities[id]?.isUpdating));

export const selectCameraAgentJob = createSelector(camerasState, state => state.agentJob);
